type SortableRoom = {
  priority?: number | null;
  price?: { amount?: number | null } | null;
};

/**
 * Orders rooms by priority ascending (lower number shown first). Rooms without a priority
 * are placed after all prioritised rooms and, among themselves, ordered by price ascending.
 */
export const byPriorityThenPrice = (a: SortableRoom, b: SortableRoom) => {
  const priorityA = a.priority ?? Infinity;
  const priorityB = b.priority ?? Infinity;
  if (priorityA !== priorityB) {
    return priorityA - priorityB;
  }
  return (a.price?.amount ?? Infinity) - (b.price?.amount ?? Infinity);
};
